/* talu-pause-offscreen-animations.js (P0-5 perf 2026-05-22)
 * Pausa animation: infinite cuando los elementos salen del viewport.
 * Ahorra 20-40% CPU/GPU en mobile low-end sin cambio visual perceptible.
 * Las animaciones siguen corriendo cuando están visibles.
 */
(function() {
  'use strict';
  if (!('IntersectionObserver' in window)) return;

  // Selectores TÄLU con animaciones continuas (shimmer, glow, float, pulse, etc.)
  var SEL = [
    '.bd-urgent-banner',
    '.bd-urgent-stock .dot',
    '.shimmer-btn', '.shimmer-pill', '.shimmer-text',
    '.shipping-progress', '.progress-fill',
    '.seal-medallion-3d', '.hero-seal', '.seal-center',
    '.gift-card-preview',
    '.como-card .emoji',
    '.lifestyle-slider',
    '.pack-banner', '.pack-banner-shimmer',
    '[data-animate-infinite]'
  ].join(',');

  function onIntersect(entries) {
    for (var i = 0; i < entries.length; i++) {
      var e = entries[i];
      var state = e.isIntersecting ? 'running' : 'paused';
      e.target.style.animationPlayState = state;
      // Para pseudo-elements ::before/::after via custom property
      e.target.style.setProperty('--ps', state);
    }
  }

  var io = new IntersectionObserver(onIntersect, {
    threshold: 0,
    rootMargin: '100px'
  });

  function init() {
    var els = document.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) io.observe(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
